import PropTypes from 'prop-types';

import Leaf from '../Leaf';

const propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string,
    mark: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

const defaultProps = {};

const Paragraph = ({ data }) => {
  const leafs = data.children.map((leaf, index) => (
    <Leaf
      key={index}
      data={leaf}
    />
  ));
  return <div>{leafs}</div>;
};

Paragraph.propTypes = propTypes;
Paragraph.defaultProps = defaultProps;

export default Paragraph;
